import Model from '../common/model';
import CustomerPondModel from './customerPond.model';

export default class MetricsModel extends Model {
  business_id: string;
  farm_site_id?: string;
  section_id?: number;
  Readings = new Array();
  pondCulture = new Object();
  pond: CustomerPondModel;
  pH: number;
  salinity: number;
  do2: number;
  temperature: number;
  tan: number;
  Nitrite: number;
  Alkalinity: number;
  Bio_Floc: number;
  orp: number;
  tds: number;
  turbidity: number;
  carbonate: number;
  bicarbonate: number;
  Hardness: number;
  Calcium: number;
  magnesium: number;
  uammonia: number;
  date: any;
  ph: boolean;
  do: boolean;
  Tan: boolean;
  Salinity: boolean;
  temp: boolean;
  Uammonia: boolean;
  custNitrite: boolean;
  custalkalinity: boolean;
  biofloc: boolean;
  Orp: boolean;
  Tds: boolean;
  Turbidity: boolean;
  Carbonate: boolean;
  bicorbonate: boolean;
  custhardness: boolean;
  custcalcium: boolean;
  magnisium: boolean;
  all: boolean;
  ABW: boolean;
  ADG: boolean;
  tbm: boolean;
  sr: boolean;
  fcr: boolean;
  dcf: boolean;
  growthAll: boolean;
  pondId: number;
  total_biomass: number;
  cumulative_feed: number;
  abw: number;
  adg: number;
  FCR: number;
  survival_rate: number;
  comparepondId: number;
  uam: number;
  pond_id: any;
  pond_culture_id: string;

  constructor() {
    super();
  }
}
